// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__17PQ-","button_orange":"styles_button_orange__1KYGh","button_red":"styles_button_red__1SKMb"};